import { Skeleton } from "./Skeleton";

export default function ShellSkeleton() {
  return (
    <div className="flex min-h-screen bg-bg" data-testid="shell-skeleton">
      <aside className="hidden w-[248px] flex-col border-r border-line bg-surface lg:flex">
        <div className="flex items-center justify-center px-4 py-6"><img src="/athanor-logo.png" alt="Athanor Lab" className="h-14 w-auto object-contain" /></div>
        <div className="space-y-2 px-3">{Array.from({ length: 7 }).map((_, i) => <Skeleton key={i} className="h-8 w-full" />)}</div>
      </aside>
      <div className="flex min-h-screen min-w-0 flex-1 flex-col">
        <header className="flex h-14 items-center justify-between border-b border-line px-4 sm:px-6"><Skeleton className="h-3.5 w-28" /><Skeleton className="h-9 w-36" /></header>
        <main className="mx-auto w-full max-w-[1320px] flex-1 p-4 sm:p-6 lg:p-8">
          <Skeleton className="h-9 w-56" /><Skeleton className="mt-3 h-4 w-80" />
          <div className="mt-8 grid grid-cols-2 gap-4 lg:grid-cols-4">{Array.from({ length: 4 }).map((_, i) => <Skeleton key={i} className="h-28 w-full rounded-lg" />)}</div>
        </main>
      </div>
    </div>
  );
}
